<script setup lang="ts">
import AddMarketView from '../sections/AddMarketView.vue';

defineProps<{
  isMarketPickerOpen: boolean;
}>();
</script>

<template>
  <AddMarketView :isMarketPickerOpen="isMarketPickerOpen" />
</template>
